import type { Maybe, ValueEvent } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { AbstractAspect } from '@adornis/filter/aspect-schemas/AbstractAspect.js';
import type { AspectConfig } from '@adornis/filter/filter-options.js';
import { html } from 'lit';
import type { ChancenRole } from './ChancenRole.js';

/**
 * @Entity ChancenRoleAspect
 */
@Entity()
export class ChancenRoleAspect extends AbstractAspect {
  static override _class = 'ChancenRoleAspect';

  constructor(doc: PartialEntityData<ChancenRoleAspect>) {
    const newDoc = {
      customID: 'role',
      ...doc,
    };
    super(newDoc);
  }

  @Field(() => ID, { default: v => v ?? '' })
  value!: string;
  @Field(() => String, { default: v => v ?? '' })
  name!: string;
}

export const ChancenRoleAspectSchema: AspectConfig<ChancenRoleAspect> = {
  aspectConstructor: ChancenRoleAspect,
  renderEditor: ({ aspectValue }) => html`
    <chancen-component-semantic-predicate-picker
      placeholder-mode="hide"
      @value-picked=${(e: ValueEvent<Maybe<ChancenRole>>) => {
        aspectValue.value = e.detail.value?._id ?? '';
        aspectValue.name = e.detail.value?.readableName ?? '';
      }}
      .valueID=${aspectValue.value}
    ></chancen-component-semantic-predicate-picker>
  `,
  renderPreview: ({ aspectValue }) => (aspectValue.name ? html` ${aspectValue.name} ` : null),
};
